import { useState } from 'react';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess';
import { PersonTypes } from '@frontend/api-person';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { InsuranceDetailsConstants, InsuranceStatusChipButton, InsuranceTabHooks } from '@frontend/insurance-tab';
import { useContactPanelShallowStore } from '@frontend/shared';
import { useModalControl } from '@frontend/design-system';

export const InsuranceStatusIcon = ({
  locationId,
  personId,
  personInfo,
  isLoading = false,
}: {
  locationId: string;
  personId: string;
  personInfo?: PersonTypes.Person;
  isLoading?: boolean;
}) => {
  const { setPersonId, setScrollTo, setSelectedTab } = useContactPanelShallowStore(
    'setPersonId',
    'setScrollTo',
    'setSelectedTab'
  );
  const verifyInsuranceModalControl = useModalControl();
  const verificationMetricModalControl = useModalControl();
  const [defaultDateRange, setDefaultDateRange] = useState<InsuranceDetailsConstants.DateRangeOptionValue>('today');
  const { Modal: VerificationModal } = InsuranceTabHooks.useGetInsuranceVerificationModal({
    verifyInsuranceModalControl,
    verificationMetricModalControl,
    defaultDateRange,
    setDefaultDateRange,
    personInfo,
    locationId,
  });
  const hasAccessToInsuranceVerification = hasSchemaACL(locationId, [
    Permission.INSURANCE_VERIFICATION_READ,
    Permission.INSURANCE_VERIFICATION_WRITE,
  ]);

  const handleInsuranceStatusClick = () => {
    handlePersonClick(true);
    setSelectedTab('insurance-tab');
  };

  const handlePersonClick = (isScrollToInsuranceDetails: boolean) => {
    setPersonId(personId, true, locationId);
    // Close Schedule Pulse Tray
    // Close Appointment Modal
    setSelectedTab('overview-tab');
    if (isScrollToInsuranceDetails) {
      setScrollTo('insurance-details');
    }
  };

  if (!hasAccessToInsuranceVerification) {
    return null;
  }

  return (
    <>
      <InsuranceStatusChipButton
        locationId={locationId}
        personId={personId}
        onClick={handleInsuranceStatusClick}
        handleVerifyStatusClick={verifyInsuranceModalControl.openModal}
        isLoading={isLoading}
      />
      {!isLoading && VerificationModal}
    </>
  );
};
